"use strict";

var PyDefUtils = require("PyDefUtils");
var utils = require("../utils");
const { getCssPrefix } = require("@runtime/runner/legacy-features");

module.exports = function(pyModule) {

    pyModule["DesignColumnPanel"] = Sk.misceval.buildClass(pyModule, function($gbl, $loc) {
        $loc["__init__"] = new Sk.builtin.func(PyDefUtils.withRawKwargs(function(kwargs, self) {
            
            var buildGridPath = function(colElement) {
                var path = "";

                var col = colElement;
                while(col.hasClass("anvil-panel-col")) {
                    var row = col.parent();
                    
                    path = row.attr("data-anvil-row-id") + "," + col.attr("data-anvil-col-id") + " " + path;
                    var col = row.parent();
                }

                return path.trim();
            }

            var newColInPath = function(gridPath) {
                var newColId = utils.getRandomStr(6);
                var rowId = gridPath.substr(0,gridPath.lastIndexOf(",")).substr(gridPath.lastIndexOf(" ")+1);
                return {
                    rowId: rowId,
                    colId: newColId,
                    path: gridPath.substr(0,gridPath.lastIndexOf(",")+1) + newColId,
                };
            }

            var newRowInPath = function(gridPath) {
                var newRowId = utils.getRandomStr(6);
                var newColId = utils.getRandomStr(6);
                return {
                    rowId: newRowId, 
                    colId: newColId, 
                    path: gridPath.substr(0, gridPath.lastIndexOf(" ")+1) + newRowId + "," + newColId,
                };
            }

            var maxChildIdxOf = function(element) {
                var maxChildIdx = -1;
                element.find(".anvil-component.belongs-to-" + self._anvil.panelId).each(function(i,c) {
                    maxChildIdx = Math.max(parseInt(c.dataset.anvilDesignerPanelChildIdx), maxChildIdx);
                });
                return maxChildIdx;
            }

            var minChildIdxOf = function(element) {
                var minChildIdx = Number.MAX_VALUE;
                element.find(".anvil-component.belongs-to-" + self._anvil.panelId).each(function(i,c) {
                    minChildIdx = Math.min(parseInt(c.dataset.anvilDesignerPanelChildIdx), minChildIdx);
                });

                return minChildIdx;
            }

            var leftOf = function(e) {
                let col = e.hasClass("anvil-panel-col");

                if (col) {
                    let cp = e.find(`>.${getCssPrefix()}col-padding`);
                    if (cp.length > 0) {
                        e = cp;
                    }
                }

                return {
                    x: e.offset().left + parseFloat(e.css("padding-left")),
                    y: e.offset().top,
                    width: 0,
                    height: e.outerHeight()
                };
            }

            var rightOf = function(e) {
                let col = e.hasClass("anvil-panel-col");

                if (col) {
                    let cp = e.find(`>.${getCssPrefix()}col-padding`);
                    if (cp.length > 0) {
                        e = cp;
                    }
                }
                return {
                    x: e.offset().left + e.outerWidth() - parseFloat(e.css("padding-right")),
                    y: e.offset().top,
                    width: 0,
                    height: e.outerHeight()
                };
            }

            var resetColWidths = function(colWidths, row) {
                row.find(">.anvil-panel-col").each(function(i,e) {
                    e = $(e);
                    var colId = e.attr("data-anvil-col-id");
                    delete colWidths[colId];
                });
                return colWidths;
            }

            var cleanupColWidths = function(colWidths) {

                // Remove settings for any columns that don't exist anymore
                for (var cid in colWidths) {
                    if (self._anvil.element.find(".anvil-panel-col-" + cid + ".belongs-to-" + self._anvil.panelId).length == 0) {
                        console.log("Deleting old colWidth", cid);
                        delete colWidths[cid];
                    }
                }

                self._anvil.element.find(".anvil-panel-row.belongs-to-" + self._anvil.panelId).each(function(i,row) {
                    var cols = $(row).find(">.anvil-panel-col");

                    var colsWithoutWidths = 0;
                    cols.each((i,col) => { colsWithoutWidths += (col.dataset.anvilColId in colWidths) ? 0 : 1 });

                    // If any cols have been resized in this row, make sure all cols have widths and that they add to 60.

                    if (colsWithoutWidths > 1 && colsWithoutWidths < cols.length) {
                        let colsSoFar = 0;
                        cols.each(function(i,e) {
                            if (i < cols.length - 1) {
                                let thisColWidth = Math.round(getColWidth($(e)) * 60);
                                colsSoFar += thisColWidth;
                                colWidths[e.dataset.anvilColId] = thisColWidth;
                            } else {
                                // Allocate remaining space to final column, to prevent rounding errors.
                                colWidths[e.dataset.anvilColId] = 60 - colsSoFar;
                            }
                        });
                    }
                });

                return colWidths;
            }

            self._anvil.cleanupLayoutProperties = function(getElementComponent, getComponentName) {

                // Runtime v3 provides lookup functions for components and names.
                getElementComponent = getElementComponent || ((element) => $(element).data("anvil-py-component"))
                getComponentName = getComponentName || ((pyComponent) => pyComponent._anvil.componentSpec.name);

                var newLayoutProperties = {};
                var newProperties = {};
                var redundantRowCols = [];

                var rows = self._anvil.element.find(".anvil-panel-row.belongs-to-" + self._anvil.panelId);

                rows.each(function(i,r) {
                    r = $(r);

                    // A row with one column containing no components (probably just another row)
                    var case1 = r.children().length == 1 && r.find(`>.anvil-panel-col>.${getCssPrefix()}col-padding>.anvil-component`).length != 1;

                    // A row with one column, containing one component, with no siblings, and not top-level
                    var case2 = r.children().length == 1 && r.find(".anvil-component.belongs-to-" + self._anvil.panelId).length == 1 && r.siblings().length == 0 && !r.parent().hasClass("anvil-panel-section-gutter");

                    if (case1 || case2) {
                        var rc = r.attr("data-anvil-row-id") + "," + $(r.children()[0]).attr("data-anvil-col-id");
                        redundantRowCols.push(rc);
                    }
                });

                if (redundantRowCols.length > 0) {

                    var components = self._anvil.element.find(".anvil-component.belongs-to-" + self._anvil.panelId);
                    components.each(function(i,componentElement) {

                        var c = $(componentElement).closest(".anvil-panel-col.belongs-to-" + self._anvil.panelId);
                        newLayoutProperties[getComponentName(getElementComponent(componentElement))] = {
                            grid_position: buildGridPath(c),
                        };

                    });
                }

                for (var n in newLayoutProperties) {
                    var lp = newLayoutProperties[n];
                    for (var i in redundantRowCols) {
                        var rc = redundantRowCols[i];

                        lp.grid_position = lp.grid_position.replace(rc,'').replace(/\s+/g, ' ').trim();
                    }
                }

                var oldColWidthsRaw = self._anvil.getPropJS("col_widths") || "{}";
                var colWidths = cleanupColWidths(JSON.parse(oldColWidthsRaw));
                var newColWidthsRaw = JSON.stringify(colWidths);
                if (oldColWidthsRaw !== newColWidthsRaw) {
                    newProperties[self._anvil.element.hasClass("anvil-designer-component-namespace") ? "" : getComponentName(self)] = {
                        col_widths: newColWidthsRaw,
                    };
                }

                return {
                    newLayoutProperties: newLayoutProperties,
                    newProperties: newProperties,
                };

            };

            self._anvil.whereWillItLand = function(x, y, width, height, mouseX, mouseY) {
                // "this" is _anvil

                var rtn = null;
                var e = document.elementFromPoint(mouseX, mouseY);

                // Make sure we don't detect components inside nested containers.
                var parentContainers = $(e).parents(".anvil-container");
                parentContainers.each(function() {
                    if (this == self._anvil.element[0]) {
                        return false; // break
                    }
                    e = this;
                });

                var newColWidths = cleanupColWidths(JSON.parse(this.getPropJS("col_widths") || "{}"));


                // Precompute options for whole new columns

                var u = {};
                var newRow = utils.getRandomStr(6);
                var newCol = utils.getRandomStr(6);
                this.element.find(".anvil-component.belongs-to-" + self._anvil.panelId).each(function(i,ce) {
                    var componentSpec = $(ce).data("anvil-py-component")._anvil.componentSpec;
                    var name = componentSpec.name;
                    var gridPos = componentSpec.layout_properties.grid_position;
                    u[name] = {
                        layout_properties: {
                            grid_position: newRow + "," + newCol + " " + gridPos,
                        },
                    };
                });

                // Only allow whole new columns if we have more than one row.
                if (this.element.find(">.anvil-panel-section").length == 1) {
                    newRow = this.element.find(".anvil-panel-row.belongs-to-" + self._anvil.panelId).first().attr("data-anvil-row-id");
                    u = {};
                }

                var newColRight = {
                    childIdx: maxChildIdxOf(this.element)+1,
                    gridPos: newRow + "," + utils.getRandomStr(6),
                    estimatedPosition: rightOf(this.element),
                    otherComponentUpdates: u,
                };

                var newColLeft = {
                    childIdx: minChildIdxOf(this.element),
                    gridPos: newRow + "," + utils.getRandomStr(6),
                    estimatedPosition: leftOf(this.element),
                    otherComponentUpdates: u,
                };


                var row = $(e).closest(".anvil-panel-row.belongs-to-" + self._anvil.panelId);
                var sharedRowLayoutProps = {};

                if (row.length) {

                    this.element.find(".anvil-designer-hover-row.belongs-to-" + self._anvil.panelId).removeClass("anvil-designer-hover-row");
                    row.addClass("anvil-designer-hover-row");

                    var rowOffset = row.offset();
                    var rowWidth = row.outerWidth();
                    var rowHeight = row.outerHeight()

                    var rowCols = row.find(">.anvil-panel-col");
                    var colCount = rowCols.length;

                    // Work out which column we're hovering over.

                    // Which column of the base grid are we over?
                    var hoverBaseCol = ((mouseX-rowOffset.left) / rowWidth);

                    // Which col element does that correspond to?
                    var colIndex = 0;
                    var totalWidthSoFar = 0;
                    for(var i = 0; i < rowCols.length; i++) {
                        var e = $(rowCols[i]);
                        totalWidthSoFar += getColWidth(e);
                        colIndex = i;

                        if (totalWidthSoFar > hoverBaseCol) {
                            break;
                        }
                    }

                    var col = $(row.find(">.anvil-panel-col")[colIndex]);

                    if (col.length) {

                        // We now have which row/col the mouse is over.
                        // Although cols are only allowed to contain one component, the col might contain a nested grid.

                        this.element.find(".anvil-designer-hover-col.belongs-to-" + self._anvil.panelId).removeClass("anvil-designer-hover-col");
                        col.addClass("anvil-designer-hover-col");

                        var colMouseX = mouseX - col.offset().left;
                        var colMouseY = mouseY - rowOffset.top;
                        var colPath = buildGridPath(col);

                        // Find the component in the current cell. We know there is one, because you can't have empty cells
                        var componentElement = col.find(`>.${getCssPrefix()}col-padding>.anvil-component`);
                        var pyComponent = componentElement.data("anvil-py-component");



                        var rightOptions = [];
                        var leftOptions = [];
                        var topOptions = [];
                        var bottomOptions = [];

                        // This adds a new level of nesting, allowing us to
                        // add a new component to a column. Only allow it if 
                        // there are actually multiple columns
                        if (componentElement.length && col.siblings().length) {
                            var u = {};
                            u[pyComponent._anvil.componentSpec.name] = {
                                layout_properties: {
                                    grid_position: colPath + " " + utils.getRandomStr(6) + "," + utils.getRandomStr(6),
                                },
                            };

                            bottomOptions.push({
                                childIdx: parseInt(componentElement.attr("data-anvil-designer-panel-child-idx"))+1,
                                gridPos: colPath + " " + utils.getRandomStr(6) + "," + utils.getRandomStr(6),
                                otherComponentUpdates: u,
                                estimatedPosition: utils.bottomOf(componentElement)
                            });

                            topOptions.push({
                                childIdx: parseInt(componentElement.attr("data-anvil-designer-panel-child-idx")),
                                gridPos: colPath + " " + utils.getRandomStr(6) + "," + utils.getRandomStr(6),
                                otherComponentUpdates: u,
                                estimatedPosition: utils.topOf(componentElement),
                            });
                        }

                        // Walk up through parent row/cols

                        var c = col;
                        var continueRight = true;
                        var continueLeft = true;
                        var continueTop = true;
                        var continueBottom = true;
                        while(c.hasClass("anvil-panel-col")) {
                            var r = c.parent();

                            if (r.parent().hasClass("anvil-panel-section-gutter")) {
                                r = r.parent().parent().parent();

                                // Assert r is now an anvil-panel-section
                                if (!r.hasClass("anvil-panel-section")) {
                                    debugger;
                                }
                            }

                            if (continueRight) {
                                // Offer to add a column to the right of c, in r.
                                var ncip = newColInPath(buildGridPath(c));
                                rightOptions.push({
                                    childIdx: maxChildIdxOf(c)+1,
                                    gridPos: ncip.path,
                                    rowId: ncip.rowId,
                                    colId: ncip.colId,
                                    estimatedPosition: rightOf(c),
                                })
                            }

                            if (continueLeft) {
                                // Offer to add a column to the left of c, in r.
                                var ncip = newColInPath(buildGridPath(c))
                                leftOptions.push({
                                    childIdx: minChildIdxOf(c),
                                    gridPos: ncip.path,
                                    rowId: ncip.rowId,
                                    colId: ncip.colId,
                                    estimatedPosition: leftOf(c),
                                });
                            }

                            if (continueTop) {
                                var nrip = newRowInPath(buildGridPath(c));
                                topOptions.push({
                                    childIdx: minChildIdxOf(r),
                                    gridPos: nrip.path,
                                    rowId: nrip.rowId,
                                    colId: nrip.colId,
                                    estimatedPosition: utils.topOf(r),
                                });
                            }

                            if (continueBottom) {
                                var nrip = newRowInPath(buildGridPath(c));
                                bottomOptions.push({
                                    childIdx: maxChildIdxOf(r)+1,
                                    gridPos: nrip.path,
                                    rowId: nrip.rowId,
                                    colId: nrip.colId,
                                    estimatedPosition: utils.bottomOf(r),
                                });
                            }

                            continueLeft = continueLeft && (c.prev().length == 0);
                            continueRight = continueRight && (c.next().length == 0);

                            c = r.parent();

                            continueTop = continueTop && r.prev().length == 0;
                            continueBottom = continueBottom && r.next().length == 0;
                        }

                        // We have reached the very edge of the grid. Add options for a whole new column.
                        
                        if ((continueRight || continueLeft) && self._anvil.element.children().length > 1) {

                            if (continueRight) {
                                rightOptions.push(newColRight);
                            }

                            if (continueLeft) {
                                leftOptions.push(newColLeft);
                            }

                        }

                        // Now duplicate the outermost drop zones, so that our edge overlay doesn't cover them up.
                        // If we get forced back in, the zone will still work.

                        let parentContainer = self._anvil.element.parent().closest(".anvil-container");
                        if (continueTop) {
                            topOptions.push($.extend({}, topOptions[topOptions.length - 1]));
                        }
                        if (continueBottom) {
                            bottomOptions.push($.extend({}, bottomOptions[bottomOptions.length - 1]));
                        }
                        if (continueLeft) {
                            leftOptions.push($.extend({}, leftOptions[leftOptions.length - 1]));
                        }
                        if (continueRight) {
                            rightOptions.push($.extend({}, rightOptions[rightOptions.length - 1]));
                        }

                        var dropZoneSizeX = 15;
                        var dropZoneSizeY = 15;

                        dropZoneSizeX = Math.min(col.outerWidth()/(leftOptions.length + rightOptions.length + 2), dropZoneSizeX);
                        dropZoneSizeY = Math.min(col.outerHeight()/(topOptions.length + bottomOptions.length), dropZoneSizeY);

                        if (componentElement.hasClass("anvil-container")) {
                            dropZoneSizeX = Math.min(dropZoneSizeX, (col.outerWidth() - col.width()) / (leftOptions.length + rightOptions.length + 2));
                        }

                        // Work out which drop zone we're in.
                        if (colMouseX < leftOptions.length * dropZoneSizeX || colMouseX < col.outerWidth()/3) {
                            // We're in the left zone
                            var optionIndex = Math.floor(colMouseX / dropZoneSizeX);

                            rtn = leftOptions[Math.max(0,leftOptions.length - optionIndex - 1)];

                        } else if ((col.outerWidth() - colMouseX) < rightOptions.length * dropZoneSizeX || ((col.outerWidth() - colMouseX)) < col.outerWidth() / 3) {
                            // We're in the right zone

                            var optionIndex = Math.floor((col.outerWidth() - colMouseX) / dropZoneSizeX);

                            rtn = rightOptions[Math.max(0, rightOptions.length - optionIndex - 1)];

                        } else if (colMouseY < topOptions.length * dropZoneSizeY) {
                            // Top zone

                            var optionIndex = Math.floor(colMouseY / dropZoneSizeY);

                            rtn = topOptions[topOptions.length - optionIndex - 1];
                        } else {
                            // Bottom zone

                            // If we are the last row in a cell, pretend we're hovering over the parent row.
                            // This cell might be much less tall than its row.
                            var rowToUse = row;
                            if (row.next().length-1) {
                                rowToUse = row.parent().parent();
                                colMouseY += col.offset().top - rowToUse.offset().top;
                            }

                            var optionIndex = Math.max(0,Math.min(Math.floor((rowToUse.outerHeight() - colMouseY) / dropZoneSizeY), bottomOptions.length-1));
                            
                            rtn = bottomOptions[bottomOptions.length - optionIndex - 1];
                        }  

                    }
                }

                let [distance, nearest] = utils.distanceToEdge(this.element, mouseX, mouseY);

                if (!rtn) {
                    // We are either outside the ColumnPanel (redirected in), or over the padding.
                    var offset = this.element.offset();

                    var rows = this.element.find(">.anvil-panel-row");

                    if (nearest == "top") {
                        rtn = {
                            childIdx: 0,
                            gridPos: utils.getRandomStr(6) + "," + utils.getRandomStr(6),
                            estimatedPosition: utils.topOf(rows.length ? rows.first() : this.element),
                        };
                    } else if (this.element.children().length > 0 && nearest == "right") {
                        rtn = newColRight;
                    } else if (this.element.children().length > 0 && nearest == "left") {
                        rtn = newColLeft;
                    } else if ($(e).closest(".anvil-panel-section.belongs-to-" + self._anvil.panelId).length > 0) {
                        if (mouseX > offset.left + this.element.outerWidth() / 2) {
                            rtn = newColRight;
                        } else {
                            rtn = newColLeft;
                        }
                    } else {
                        rtn = {
                            childIdx: maxChildIdxOf(this.element)+1,
                            gridPos: utils.getRandomStr(6) + "," + utils.getRandomStr(6),
                            estimatedPosition: utils.bottomOf(rows.length ? rows.last() : this.element),
                        };
                    }
                }

                if (distance < Math.min(8, this.element.outerHeight() / 3)) {
                    rtn.redirectToElement = self._anvil.element.parent().closest(".anvil-container");
                }
                // Now that we know which row we'll fall into, inherit any shared layout properties from other components in that row (if any)

                var componentInRow = self._anvil.element.find(`.anvil-panel-row-${rtn.rowId}>.anvil-panel-col>.${getCssPrefix()}col-padding>.anvil-component`);
                if (componentInRow.length > 0) {
                    var lps = componentInRow.first().data("anvil-py-component")._anvil.layoutProps;
                    if ('row_background' in lps) {
                        sharedRowLayoutProps['row_background'] = lps['row_background'];
                    }
                    if ('full_width_row' in lps) {
                        sharedRowLayoutProps['full_width_row'] = lps['full_width_row'];
                    }
                }

                var row = self._anvil.element.find(".anvil-panel-row-"+rtn.rowId);
                if (row.length > 0) {
                    newColWidths = cleanupColWidths(newColWidths);
                }


                rtn.otherComponentUpdates = rtn.otherComponentUpdates || {};
                rtn.otherComponentUpdates[this.element.hasClass("anvil-designer-component-namespace") ? "" : this.componentSpec.name] = {
                    properties: { 
                        col_widths: JSON.stringify(newColWidths),
                    },
                };

                var returnObj = {
                    childIdx: rtn.childIdx || 0, 
                    layoutProperties: {
                        grid_position: rtn.gridPos,
                    },
                    otherComponentUpdates: rtn.otherComponentUpdates,
                    estimatedPosition: rtn.estimatedPosition || {x:0, y:0, width:0, height:0},
                    estimatedPositionContainer: utils.positionOf(self._anvil.element),
                    guidelines: [],
                    redirectToElement: rtn.redirectToElement,
                };

                $.extend(returnObj.layoutProperties, sharedRowLayoutProps);
                return returnObj;
            }

            self._anvil.getHandles = function(pyChild) {
                var handles = [];

                if (pyChild) {
                    // Get layout handles for pyChild
                    // ColumnPanel doesn't provide any.
                } else {
                    // Get our own handles
                    var cols = self._anvil.element.find(".anvil-panel-col.belongs-to-" + self._anvil.panelId).filter(function (i, e) {
                        return $(e).next().length;
                    });

                    cols.each(function(i,c) {
                        c = $(c);
                        var offset = c.offset();
                        let label = undefined;
                        try {
                            label = localStorage.columnPanelTriedCtrlDrag ? undefined : "Ctrl-drag for fine control";
                        } catch (e) {}
                        handles.push({
                            colId: c.attr("data-anvil-col-id"),
                            x: offset.left + c.outerWidth() - 1,
                            y: offset.top+2,
                            width: 2,
                            height: c.parent().outerHeight()-4,
                            cursor: "ew",
                            owner: self._anvil.element.hasClass("anvil-designer-component-namespace") ? "" : self._anvil.componentSpec && self._anvil.componentSpec.name,
                            showOnChildHover: true,
                            label: label,
                        })
                    });
                }

                return handles;
            };

            var getColWidth = function(col) {
                return col.outerWidth() / col.parent().outerWidth();
            }

            self._anvil.handleGrab = function(handle, mouseX, mouseY) {
                var col = self._anvil.element.find(".anvil-panel-col-" + handle.colId);
                var row = col.parent();
                var offset = 0;
                row.find(">.anvil-panel-col").each((i,e) => {
                    if (e == col[0]) return false;
                    offset += parseInt($(e).css("flex-grow"));
                })
                return {
                    mouseX: mouseX,
                    mouseY: mouseY,
                    colOffset: offset,
                    colWeight: parseInt(col.css("flex-grow")),
                    nextColWeight: parseInt(col.next().css("flex-grow")),
                };
            };

            self._anvil.handleDrag = function(handle, grab, mouseX, mouseY, metaKey) {

                var col = self._anvil.element.find(".anvil-panel-col-" + handle.colId);
                var totalCols = 60;
                var pixelsPerCol = col.parent().outerWidth() / totalCols;

                var dxCols = Math.round((mouseX-grab.mouseX)/pixelsPerCol);

                if (!metaKey) {
                    let snap = Math.round((grab.colOffset + grab.colWeight + dxCols) / 5) * 5;
                    dxCols = snap - grab.colOffset - grab.colWeight;
                } else {
                    try {
                        localStorage.columnPanelTriedCtrlDrag = true;
                    } catch (e) {}
                }

                var minColWidth = Math.ceil(30/pixelsPerCol);
                dxCols = Math.max(dxCols, minColWidth-grab.colWeight);
                dxCols = Math.min(dxCols, grab.nextColWeight-minColWidth);

                col.css("flex-grow", grab.colWeight + dxCols);
                col.next().css("flex-grow", grab.nextColWeight - dxCols);

                handle.x = col.offset().left + col.outerWidth() - 1;
                return handle;
            };

            self._anvil.handleDrop = function(handle, grab, mouseX, mouseY) {

                var r = { properties: {}};

                var colWidths = JSON.parse(self._anvil.getPropJS("col_widths") || "{}");
                // Fix the widths of all columns in the row the handle is in.
                var col = self._anvil.element.find(".anvil-panel-col-" + handle.colId);
                var colsInRow = col.siblings().addBack();

                colsInRow.each(function(i,e) {
                    e = $(e);
                    colWidths[e.attr("data-anvil-col-id")] = parseInt(e.css("flex-grow"));
                });

                cleanupColWidths(colWidths);

                var selfName = self._anvil.element.hasClass("anvil-designer-component-namespace") ? "" : self._anvil.componentSpec && self._anvil.componentSpec.name;
                r.properties[selfName] = {
                    col_widths: JSON.stringify(colWidths),
                };

                return r;
            }

            self._anvil.handleDoubleClick = function(handle) {
                var r = { properties: {}};

                var colWidths = JSON.parse(self._anvil.getPropJS("col_widths") || "{}");
                // Remove widths of all columns in the row the handle is in.
                var col = self._anvil.element.find(".anvil-panel-col-" + handle.colId);
                var colsInRow = col.siblings().addBack();

                colsInRow.each(function(i,e) {
                    e = $(e);
                    delete colWidths[e.attr("data-anvil-col-id")];
                });

                cleanupColWidths(colWidths);

                var selfName = self._anvil.element.hasClass("anvil-designer-component-namespace") ? "" : self._anvil.componentSpec && self._anvil.componentSpec.name;
                r.properties[selfName] = {
                    col_widths: JSON.stringify(colWidths),
                };
                return r;
            }

        }));


    }, 'DesignColumnPanel', [pyModule["ColumnPanel"]]);
};